import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SubscriptionInformationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof SubscriptionInformationResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

type Props = {
  enabled?: boolean
  onSuccess?: OnSuccessFn
}

export const getSubscriptionQueryKey = () => ["subscription"]

export const subscriptionQuery = ({ enabled = true, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getSubscriptionQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/billing/subscription")
      onSuccess?.(data)
      return data.data
    },
    enabled,
    refetchInterval: 10 * 60 * 1000, // 10 minutes
  })
}
